export enum FileType {
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  XLS = "application/vnd.ms-excel",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PDF = "application/pdf",
  ZIP = "application/zip",
  CZIP = "application/zip-compressed",
  XZIP = "application/x-zip-compressed",
  RAR = "application/x-rar-compressed",
  XRAR = "application/x-compressed",
  JEPG = "image/jpeg",
  PNG = "image/png",
  SIGN = "application/pgp-signature",
  ODT = "application/vnd.oasis.opendocument.text",
}
